module.exports = __webpack_public_path__ + "img/header-engagementRingsLabGrownDiamonds.8e2710d.webp";